// extracted by mini-css-extract-plugin
export default {"timer":"timer___bfd851ccc51c5c3b"};